remitRegisterModule.directive('remittanceContracts', function factory() {
    return{
        templateUrl: 'app/modules/remittance/directives/remittance-contracts-directive.html',
        replace: true,
        transclude: false,
        restrict: 'E',
        controller: 'remitRegisterController'
    };
});